module.exports = __webpack_public_path__ + "static/HONDA CITY-0ae1161e64929b2ed3423569aab80dbc.png";